import {Action} from '@ngrx/store';
import {Content} from '../interfaces/content.interface';

export const SET_CONTENT = '[CONTENT] set content';
export const DISMIS_CONTENT = '[CONTENT] dismis content';

export class SetContent implements Action {
  readonly type = SET_CONTENT;
  constructor(public payload: Content) {}
}

export class DismisContent implements Action {
  readonly type = DISMIS_CONTENT;
  constructor(public payload: Content) {}
}

export type Actions = SetContent | DismisContent;
